import { AdOfferLineVM, LandingCategoryVM, LandingKiemeltVM } from "../../../client/swaggerClient";

export interface LandingPageCategoriesProps {
  categories: LandingCategoryVM[] | undefined
}

export interface LandingPageKiemeltekProps {
  kiemeltek: LandingKiemeltVM | undefined
}

export interface LandingPageAdOfferLineProps {
  adOfferLine: AdOfferLineVM
}

export enum KiemeltekNavButtonType {
  Next,
  Prev,
  First
}

export enum LandingPageBanner {
  CategoryAlatt = "CategoryAlatt"
}